import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import YearlyCalendar from "../../shared/YearlyCalendar";
import closeSvg from "../../assets/images/uncheck.svg";
import filterSvg from "../../assets/images/filter.svg";
import Select from "react-select";
import {
  SlTab,
  SlTabGroup,
  SlDrawer,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { formatAmount, OddMonths, roles, alphabets, BrandsTypes  } from "../../utils/constants";
import { SetComponentId } from "../../redux/counterSlice";
import config from "../../config";
import SalesTrajectory from "./SalesTrajectory";
import { Toast } from "../../shared/Toast";

function BrandsReport() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(48));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const searchWord = useSelector((state) => state.Head.adssearch);

  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedList, setSelectedList] = useState(localStorage.getItem("selectedSalesList") && salesUsersList?.length > 1 &&
    JSON.parse(localStorage.getItem("selectedSalesList")).length
    ? salesUsersList.filter((item) =>
        JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
          item.value
        )
      )
    : salesUsersList?.length > 1 ? [] : []);
  const [salesPerson_id, setSalesPerson_id] = useState(
    salesUsersList?.length > 1 ? localStorage.getItem("selectedSalesList") &&
      JSON.parse(localStorage.getItem("selectedSalesList")).length
      ? salesUsersList.filter((item) =>
          JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
            item.value
          )
        )[0]?.value || -1
      : salesUsersList[0]?.value
    : -1);
  const [showFilter, setShowFilter] = useState(false);
  const [scrollTo, setScrollTo] = useState(null);

  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
        salesUsersList.map((item) =>{
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )]);
  const [searchFilter, setSearchFilter] = useState('')
const [showUsersFilter, setShowUsersFilter] = useState(JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false)
const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)

  useEffect(() => {
    getData();
  }, [searchWord, selectedYear, salesPerson_id]);
  const getData = async () => {
    try {
      setLoader(true);
      let result = await API({
        url: "brands_report/get",
        method: "POST",
        responseType: "json",
        data: {
          search: searchWord,
          year: selectedYear,
          sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
        },
      });
      if (result.code === 200) {
        setData(result.data.result);
        setHeaders(result.data.headers);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error @ BrandsReport of getData()", error);
    }
  };

  const salesTabChange = async (sales_id) => {
    setData([]);
    setSalesPerson_id(sales_id);
  };
  const onSlSalesChange = (selected) => {
    setSelectedList(selected || []);
    localStorage.setItem(
      "selectedSalesList",
      JSON.stringify(selected.map((item) => item.value))
    );
    // if (salesPerson_id !== -1) {
      setSalesPerson_id( salesUsersList?.length > 1
        ? selected[selected.length - 1]?.value || -1
        : -1)
        document
        .getElementById(`${selected[selected.length - 1]?.value}`)
        .scrollIntoView({ behavior: "smooth" });
    // }
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  useEffect(() => {
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        setScrollTo(null);
      }
    }
  }, [scrollTo]);

  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const handleRemove = (event) => {
    const sales_person_id = event;
    let tempArray = selectedList.filter(item => item.value !== +sales_person_id)
    setSelectedList(tempArray)
    let slideToId = salesPerson_id
    if(+sales_person_id === salesPerson_id){
      setSalesPerson_id(tempArray[0].value)
      slideToId = tempArray[0].value
    }
    localStorage.setItem("selectedSalesList", JSON.stringify(tempArray.map(item => item.value)))
    document?.getElementById(slideToId)?.scrollIntoView({ behavior: "smooth" });
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
      try {
        if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
        else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
      } catch (error) {
        console.error("Error @ closeUsersFilter", error)
      }
    }

  return (
    <div className="d-flex items-start gap-2 flex-col brand_report">
      <div className="p-1 d-flex justify-end items-center gap-2 w-full mt-2 select-field">
        {/* {salesUsersList?.length ? (
          <div className="z-10">
            <Select
              type="text"
              className="mb-2"
              name="sales_person_id"
              placeholder="Sales Person"
              value={selectedList}
              onChange={(selected) => {
                onSlSalesChange(selected);
              }}
              options={[...salesUsersList]}
              isMulti
            />
          </div>
        ) : null} */}
        <YearlyCalendar startYear={2023} endYear={2100} />
        {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div> : null}
      </div>
      {/* <div className="d-flex justify-end w-full m-1">
        <img
          src={filterSvg}
          className="mobileOnly w-6"
          onClick={() => setShowFilter(true)}
          alt="filter"
        ></img>
      </div> */}
      <SlTabGroup className="tableResponsive">
        {!(
          salesUsersList?.length > 1
        ) && (
          <SlTab
            onClick={() => {
              salesTabChange(-1);
            }}
            slot="nav"
            panel="general"
            active={salesPerson_id === -1}
          >
            {localStorage.getItem("name")}
          </SlTab>
        )}
        {selectedList.map((item) => {
          return (
            <SlTab
              slot="nav"
              closable={selectedList.length > 1}
              onSlClose={() => handleRemove(item.value)}
              panel={item.value}
              onClick={() => {
                salesTabChange(item.value);
              }}
              active={salesPerson_id === item.value}
              id={`${item.value}`}
            >
              {item.label}
            </SlTab>
          );
        })}
        <SalesTrajectory year={selectedYear} salesPerson_id={salesPerson_id} setScrollTo={setScrollTo} />
        <div class="overflow-scroll max-h-[30vh] mt-3 relative">
          {/* <ScrollContainer> */}
          <table class="splScrollableBrandReport table">
            <thead className="stickyTop">
              <tr>
                <th className="stickyLeft mobHide">#</th>
                <th className="stickyLeft"> Client Name</th>
                {headers.map((month) => {
                  if (OddMonths.includes(month.name)) {
                    return <th className="bg-[#F6F6F6]"> {month.name}</th>;
                  } else {
                    return <th className=""> {month.name}</th>;
                  }
                })}
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data?.map((brand, index) => {
                  return (
                    <tr id={brand?.brand_name}>
                      <td className="stickyLeft mobHide">{index + 1}</td>
                      <td
                        className="stickyLeft truncate"
                        title={brand.brand_name}
                      >
                        {brand.brand_name}
                      </td>
                      {brand.monthWiseData.map((item, index) => {
                        return true ? (
                          <td
                            className={
                              OddMonths.includes(item.name) ? "oddBg" : ""
                            }
                          >
                            <div class="brand-counts">
                              <div class="tCount">
                                <ul>
                                  <li
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={item?.interOutlays?.outlay || "-"}
                                  >
                                    <span>Outlay:</span>{" "}
                                    {formatAmount(item?.interOutlays?.outlay) ||
                                      "-"}
                                  </li>
                                  <li
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={item?.effort?.spent || "-"}
                                  >
                                    <span>Spent:</span>{" "}
                                    {formatAmount(item?.effort?.spent) || "-"}
                                  </li>

                                  <li
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={
                                      item?.target || '-'
                                    }
                                  >
                                    <span>Target:</span>{" "}
                                    {formatAmount(item?.target || '-')}
                                  </li>
                                </ul>
                              </div>
                              <div class="tHead">
                                <h6>Intr. Count</h6>
                                <h6>Known</h6>
                                <h6>Unknown</h6>
                              </div>
                              <div class="tBody">
                                <p className={item?.interOutlays?.ids?.length ? "blue": ""}>{item?.interOutlays?.ids?.length || "-"}</p>
                                <p className={+item?.effort?.known ? 'red' : ""}>{+item?.effort?.known || "-"}</p>
                                <p className={+item?.effort?.unknown ? 'green': ""}>{+item?.effort?.unknown || "-"}</p>
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td colSpan={2} key={index} className="text-center">
                            <span className="w-3 h-3 rounded-full block bg-[#621A1A]"></span>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="14" />
            ) : (
              <TableLoader colspan="14" />
            )}
          </table>
          {/* </ScrollContainer> */}
        </div>
      </SlTabGroup>
      {/* <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex items-center gap-3 flex-wrap justify-between">
            {
              <aside className="flex items-center gap-3 justify-center  flex-wrap ">
                {salesUsersList?.length ? (
                  <div className="z-10">
                    <Select
                      type="text"
                      className="mb-2"
                      name="sales_person_id"
                      placeholder="Sales Person"
                      value={selectedList}
                      onChange={(selected) => {
                        onSlSalesChange(selected);
                      }}
                      options={[...salesUsersList]}
                      isMulti
                    />
                  </div>
                ) : null}
                <YearlyCalendar startYear={2023} endYear={2100} />
              </aside>
            }
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer> */}
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    </div>
  );
}

export default BrandsReport;
